export type IphoneMonitoringTopic = {
  slug: string
  path: string
  title: string
  seoDescription: string
  heroSubtitle: string
  summary: string
  highlights: string[]
  overview: string[]
  ctaLabel: string
  ctaTarget: string
}

export const iphoneMonitoringTopics: IphoneMonitoringTopic[] = [
  {
    slug: "parental-controls",
    path: "/features/iphone-monitoring/parental-controls",
    title: "Apple Parental Controls & Family Rules",
    seoDescription:
      "How Joey partners with Screen Time and Family Sharing so parents get consent-based monitoring, not spyware.",
    heroSubtitle: "Use Apple's built-in controls plus Joey's AI insights to keep boundaries clear.",
    summary:
      "Walkthroughs for turning on Screen Time, syncing messages with Joey Desktop, and setting expectations with your child so Joey stays trusted.",
    highlights: [
      "Screen Time setup checklists with screenshots",
      "How to explain Joey to your child and set boundaries",
      "Consent-first monitoring: alerts, not surveillance",
    ],
    overview: [
      "Step-by-step setup for Screen Time, content filters, and communication limits.",
      "How Joey Desktop syncs messages with mutual consent.",
      "Scripts for talking with kids about privacy and how alerts work.",
    ],
    ctaLabel: "Get Joey + Screen Time guide",
    ctaTarget: "/get-started",
  },
  {
    slug: "snapchat",
    path: "/features/iphone-monitoring/snapchat",
    title: "Snapchat Monitoring & Risks",
    seoDescription:
      "How Joey summarizes Snap activity, streak pressure, disappearing chats, and private stories without screenshots.",
    heroSubtitle: "Dealing with disappearing messages and private stories.",
    summary:
      "Understand how Joey surfaces risky patterns from Snap screenshots, screenshots from your child, and conversational context across iMessage.",
    highlights: [
      "Spotting streak pressure, toxic stories, and screenshot drama",
      "How to coach kids when messages auto-delete",
      "Roadmap for deeper Snap integrations",
    ],
    overview: [
      "Why Snap is hard to monitor and how Joey bridges the gap with patterns from iMessage, photos, and reports.",
      "Conversation starters for when alerts mention Snap.",
      "Roadmap for upcoming Snap categories (stories, best-friends, location).",
    ],
    ctaLabel: "See Joey's Snap insights",
    ctaTarget: "/features/iphone-monitoring",
  },
  {
    slug: "youtube-google",
    path: "/features/iphone-monitoring/youtube-google",
    title: "YouTube & Google Activity",
    seoDescription:
      "How Joey summarizes searches, history, and risky recommendations from YouTube + Google to flag early concerns.",
    heroSubtitle: "Search + video history, summarized for parents.",
    summary:
      "Learn what Joey collects from Google accounts, how we classify concerning searches, and how alerts translate into coaching moments.",
    highlights: [
      "Weekly digest of top searches & watched topics",
      "Categories for self-harm, violence, explicit content",
      "Recommendations for YouTube Supervised experiences",
    ],
    overview: [
      "Connecting your child's Google account and what data Joey ingests.",
      "How alerts categorize risk across search queries and watch history.",
      "When to escalate repeated risky searches to Joey Support.",
    ],
    ctaLabel: "Review search insights",
    ctaTarget: "/features/iphone-monitoring",
  },
  {
    slug: "joey-desktop",
    path: "/features/iphone-monitoring/joey-desktop",
    title: "Joey Desktop & Weekly Syncs",
    seoDescription:
      "Step-by-step guide to installing Joey Desktop, syncing iMessages, and keeping backups secure.",
    heroSubtitle: "Set up Joey Desktop in under 10 minutes.",
    summary:
      "Everything parents need to install Joey Desktop, run the first sync, and receive their first report.",
    highlights: [
      "Mac + Windows setup walk-through with screenshots",
      "Troubleshooting cable + Wi-Fi sync issues",
      "How Joey stores encrypted backups securely",
    ],
    overview: [
      "System requirements, cable tips, and what to expect during the first sync.",
      "How to schedule weekly syncs so Smart Alerts stay fresh.",
      "Security and privacy guardrails for encrypted backups.",
    ],
    ctaLabel: "Install Joey Desktop",
    ctaTarget: "/get-started",
  },
]
